<template>
  <transition name="fade">
    <div :style="positionMenuStyle">
      <div class="list-group">
        <a
          href="#"
          v-for="(item,index) in config.contextualMenuConfig"
          :key="index"
          class="list-group-item list-group-item-action"
        >
          <i class="fas fa-copy"></i>
          &nbsp;{{item.string}}
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref } from "@/components/puntatori";
import Vue from "vue";
//i pulsanti azioni devono essere un componente a se stante
//header componente ??
//riga componente ? in futuro magari ?

export default {
  name: "crudTableContextualMenu",
  directives: {},
  props: ["config", "trItem", "contextualMenu"],
  computed: {},
  data() {
    return {
      positionMenuStyle: "",
      //size in vw
      width: 15,
      //size in vh
      height: 35,

      hover: false,
      //window -> javascript object
      window: window
    };
  },
  computed: {},
  methods: {
    drawMenu(posX, posY, width, height) {
      var x = posX;
      var y = posY;
      var width_px = (width * window.innerWidth) / 100;
      var height_px = (height * window.innerHeight) / 100;
      console.log(window);
      if (window.innerWidth < x + width_px) {
        x = x - width_px;
      }
      if (window.innerHeight < y + height_px) {
        y = y - height_px;
      }
      this.positionMenuStyle =
        "top:" +
        y +
        "px;" +
        "left:" +
        x +
        "px;width:" +
        width_px +
        "px;height:" +
        height_px +
        "px;";
    }
  },
  mounted() {
    this.drawMenu(
      this.contextualMenu.clientX,
      this.contextualMenu.clientY,
      this.width,
      this.height
    );
  },
  watch: {
    contextualMenu() {
      this.drawMenu(
        this.contextualMenu.clientX,
        this.contextualMenu.clientY,
        this.width,
        this.height
      );
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

div {
  position: fixed;
  z-index:9999;
 /* background-color:  red;*/
}

.list-group{
  width:inherit;
  height:auto;
}


</style>
